import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import { BASE_URL } from '../apiConfig'

// export const fetchBranchReport = createAsyncThunk(
//   'fetchBranchReport',
//   async ({ jwtBearer }) => {
//     const response = await fetch(`${BASE_URL}pipeline/branch/`, {
//       headers: {
//         Authorization: `Bearer ${jwtBearer}` // Include the bearer token in the request header
//       }
//     })
//     return response.json()
//   }
// )

export const fetchBranchReport = createAsyncThunk(
  'fetchBranchReport',
  async ({ jwtBearer }, { rejectWithValue }) => {
    try {
      const response = await fetch(`${BASE_URL}pipeline/branch/`, {
        headers: {
          Authorization: `Bearer ${jwtBearer}`
        }
      });

      if (!response.ok) {
        if (response.status === 401) {
          window.location.reload();
        }
        const errorData = await response.json();
        return rejectWithValue(errorData);
      }

      return await response.json();
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);


const branchReportSlice = createSlice({
  name: 'branchReports',
  initialState: {
    isLoading: false,
    data: null,
    isError: false
  },
  extraReducers: builder => {
    builder.addCase(fetchBranchReport.pending, (state, action) => {
      state.isLoading = true
    })
    builder.addCase(fetchBranchReport.fulfilled, (state, action) => {
      state.isLoading = false
      state.data = action.payload
    })
    builder.addCase(fetchBranchReport.rejected, (state, action) => {
      console.log('Error', action.payload)
      state.isError = true
    })
  }
})

export default branchReportSlice.reducer
